export default "__VITE_ASSET__Dq52xL2j__"